var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: [_vm.noMargin ? "" : "mb-2"] },
    [
      _vm._t("content", [
        _vm._v(_vm._s(_vm.$t(_vm.title)) + ": "),
        _c("b", [_vm._v(_vm._s(_vm.distributionName))])
      ]),
      _vm._v(" "),
      _vm.required
        ? _c("i", { staticClass: "fas fa-asterisk icon red" }, [
            _c("span", { staticClass: "sr-only" }, [
              _vm._v(_vm._s(_vm.$t("Icon.Required")))
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.instructionKey
        ? _c("tooltip-icon", { attrs: { content: _vm.$t(_vm.instructionKey) } })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }